import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { AttributeString, attributeStringEnumParser } from '~app-ui-new/utils';

import { UiNewButtonBase } from '../base.component';

export enum ButtonIconVariant {
	FILLED_PRIMARY = 'FILLED_PRIMARY',
	WARN = 'WARN',
}

@Component({
	selector: '[uiNewButtonIcon]',
	templateUrl: './icon.component.html',
	styleUrls: ['./icon.component.scss', '../base.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
})
export class UiNewButtonIconComponent extends UiNewButtonBase {
	protected extraClassesKeys: Array<keyof this> = ['variant'];

	private _variant: ButtonIconVariant | null = null;

	@Input('variant')
	public set variant(variant: AttributeString<ButtonIconVariant>) {
		this._variant = attributeStringEnumParser(variant, ButtonIconVariant, null);
	}

	public get variant() {
		return this._variant as AttributeString<ButtonIconVariant>;
	}
}
